import DB from "@/common/utils/db";

/**
 * @description 获取link
 */

export function subscriptionList(query) {
    return DB({
        url: "v1/positions/subscription",
        method: "get",
        params: query
    });
}

/**
 * @description 获取职位列表
 */
export function getPositionList(query) {
  return DB({
    url: "v1/positions/subscription/positionList ",
    method: "get",
    params: query
  });
}

/**
 * @description 保存订阅
 */

export function subscriptionSave(query) {
    return DB({
        url: "v1/positions/subscription",
        method: "post",
        params: query
    });
}

/**
 * @description 获取职能数据
 */
export function getPositionTitle(query) {
  return DB({
    url: "v1/metadata/positionTitle",
    method: "get",
    params: query
  })
}

/**
 * @description 获取SPA和职位标签
 */

export function matchAssistantOptions(query) {
    return DB({
        url: "v1/positions/matchAssistantOptions.",
        method: "get",
        params: query
    });
}


/**
 * @description 公司联想
 */

export function getSuggest(query) {
    return DB({
      url: 'v1/metadata/suggest',
      method: 'get',
      params: query
    })
  }